module.exports = __webpack_public_path__ + "static/media/services-img2.9e3e74a6.svg";